(function () {
  'use strict';

  const root = document.querySelector('[data-ls-rankings]');
  if (!root || root._rankings) return;
  const scope = root.closest('.ls-rankings');
  const readJSON = (el) => (el ? JSON.parse(el.textContent || 'null') : null);
  const config = readJSON(scope.querySelector('[data-ls-rankings-config]'));
  if (config && config.reviewerLogos) window.LsReviewerLogos = config.reviewerLogos;
  const live = root.querySelector('[data-rb=live]');
  const status = root.querySelector('[data-rb=status]');

  window.LsRankingsMoney = config.money;

  // Bands are defined in the shop currency (USD); variant prices arrive in the
  // visitor's presentment currency, so scale the thresholds by Shopify's rate.
  function localizeBands() {
    const bands = window.LinsoulRankingsModel?.BANDS;
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    if (!bands || bands._localized) return;
    const nice = (n) => {
      if (!Number.isFinite(n) || n < 10) return Number.isFinite(n) ? Math.round(n) : n;
      const step = 10 ** (Math.floor(Math.log10(n)) - 1);
      return Math.round(n / step) * step;
    };
    const format = new Intl.NumberFormat(config.money.locale || 'en-US', {
      style: 'currency',
      currency: config.money.currency || 'USD',
      maximumFractionDigits: 0,
    }).format;
    Object.keys(bands).forEach((key) => {
      const band = bands[key];
      band[0] = nice(band[0] * rate);
      band[1] = nice(band[1] * rate);
      const option = root.querySelector('[data-filter="band"] option[value="' + key + '"]');
      if (option) {
        option.textContent = Number.isFinite(band[1])
          ? format(band[0]) + '–' + format(band[1])
          : 'Over ' + format(band[0]);
      }
    });
    Object.defineProperty(bands, '_localized', { value: true });
  }

  const snippetCache = new Map();

  function pickSnippets(doc) {
    const widget = doc.querySelector('[data-ls-review-widget]');
    if (!widget) return [];
    return [...widget.content.querySelectorAll('.jdgm-rev')]
      .map((el) => ({
        score: Number(el.querySelector('.jdgm-rev__rating')?.dataset.score) || 0,
        verified: el.dataset.verifiedBuyer === 'true',
        author: (el.querySelector('.jdgm-rev__author')?.textContent || '').trim(),
        date: el.querySelector('.jdgm-rev__timestamp')?.getAttribute('datetime') || '',
        title: (el.querySelector('.jdgm-rev__title')?.textContent || '').trim(),
        body: (el.querySelector('.jdgm-rev__body')?.textContent || '').replace(/\s+/g, ' ').trim(),
      }))
      .filter((r) => r.score >= 4 && r.body.length >= 30)
      .sort((a, b) => b.score - a.score || b.verified - a.verified || Math.min(b.body.length, 280) - Math.min(a.body.length, 280))
      .slice(0, 2);
  }

  function snippetHTML(r) {
    const esc = (s) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const body = r.body.length > 280 ? r.body.slice(0, 277).replace(/\s+\S*$/, '') + '…' : r.body;
    const [first = '', second = ''] = r.author.split(/\s+/);
    const name = first + (/^\p{L}/u.test(second) ? ' ' + second.charAt(0) + '.' : '');
    const date = r.date ? new Date(r.date).toLocaleDateString(config.money.locale || 'en', { month: 'short', year: 'numeric' }) : '';
    return (
      '<blockquote class="ls-snippet"><div class="ls-snippet-stars" aria-label="' + r.score + ' out of 5 stars">' +
      '★★★★★'.slice(0, r.score) + '<span>' + '★★★★★'.slice(r.score) + '</span></div>' +
      (r.title ? '<strong>' + esc(r.title) + '</strong>' : '') + '<p>' + esc(body) + '</p><footer>' + esc(name) +
      (r.verified ? ' · Verified buyer' : '') + (date ? ' · ' + esc(date) : '') + '</footer></blockquote>'
    );
  }

  window.LsRankingsReviewSnippets = async (handle, el) => {
    if (!el || !handle) return;
    try {
      if (config.reviewsLoading && !el.childElementCount) {
        const label = document.createElement('span');
        label.className = 'ls-loading';
        label.setAttribute('role', 'status');
        label.textContent = config.reviewsLoading;
        el.replaceChildren(label);
      }
      if (!snippetCache.has(handle)) {
        const url = new URL('/products/' + handle, window.location.origin);
        url.searchParams.set('section_id', 'ls-review-snippets');
        snippetCache.set(
          handle,
          fetch(url, { credentials: 'same-origin' })
            .then((r) => (r.ok ? r.text() : ''))
            .then((t) => pickSnippets(new DOMParser().parseFromString(t, 'text/html')))
        );
      }
      const snippets = await snippetCache.get(handle);
      if (el.isConnected) {
        if (snippets.length) el.innerHTML = snippets.map(snippetHTML).join('');
        else el.querySelector(':scope > .ls-loading')?.remove();
      }
    } catch (error) {
      console.warn(error);
      el.querySelector(':scope > .ls-loading')?.remove();
    }
  };

  function fail(error) {
    console.error(error);
    const box = root.querySelector('[data-rb=load-error]');
    root.querySelectorAll('.ls-rb-skel').forEach((row) => row.remove());
    if (status && box) status.textContent = '';
    if (box) {
      box.hidden = false;
      box.querySelector('[data-rb-reload]')?.addEventListener('click', () => window.location.reload());
      if (live) live.textContent = box.querySelector('h2')?.textContent || '';
    }
  }

  function pageURL(page) {
    const url = new URL(window.location.href);
    const view = url.searchParams.get('view');
    url.search = '';
    if (view) url.searchParams.set('view', view);
    url.searchParams.set('section_id', config.sectionId);
    url.searchParams.set('page', page);
    return url.toString();
  }

  async function fetchPage(page) {
    const response = await fetch(pageURL(page), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Rankings catalog page ' + page + ' returned ' + response.status);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    return readJSON(doc.querySelector('[data-ls-rankings-catalog]'));
  }

  async function loadCatalog() {
    const first = readJSON(scope.querySelector('[data-ls-rankings-catalog]'));
    const rest = [];
    for (let page = 2; page <= first.pages; page += 1) rest.push(fetchPage(page));
    const pages = [first, ...(await Promise.all(rest))];
    const seen = new Set();
    return pages.flatMap((p) => p.products).filter((p) => !seen.has(p.h) && seen.add(p.h));
  }

  function loadScript(src) {
    if (window.LinsoulD3) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = () => reject(new Error('Could not load ' + src));
      document.head.appendChild(s);
    });
  }

  const asArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
  const number = (v) => (v === null || v === undefined || v === '' ? null : Number(v));

  function toProduct(p, taxonomy) {
    const t = (!p.m && taxonomy[p.h]) || [];
    const variants = (p.v || []).map(([label, price, available]) => ({ label, price, available }));
    const anyAvailable = variants.some((v) => v.available);
    return {
      handle: p.h,
      name: p.n,
      brand: p.b,
      type: t[0] || p.t,
      signature: p.sig || t[1] || null,
      secondary: asArray(p.sec || t[2]),
      configuration: p.cfg || t[3] || null,
      technology: asArray(p.tech || t[4]),
      url: new URL('/products/' + p.h, window.location.origin).href,
      image: p.i || '',
      publishedAt: p.pd || null,
      status: 'active',
      published: true,
      fullProductVariant: true,
      onlineRetrieved: true,
      approval: 'approved',
      liveValidated: true,
      variants: variants.map((v) => ({
        label: anyAvailable ? v.label : v.label === 'Default Title' ? 'Sold out' : v.label + ' (sold out)',
        price: v.price,
        eligible: true,
        orderable: anyAvailable ? v.available : true,
        available: anyAvailable ? v.available : true,
      })),
    };
  }

  function toOwner(p, product) {
    if (!p.r) return null;
    const [average, scaleMax, count] = p.r.map(Number);
    if (!(average > 0) || !(count > 0) || scaleMax !== 5) return null;
    return {
      status: 'live',
      average,
      scaleMin: 1,
      scaleMax: 5,
      count,
      sourceURL: product.url,
      checked: config.checked,
      method: '',
      provider: 'Linsoul store reviews',
    };
  }

  function toEditorial(r, p) {
    if (!r || (r.product_handle && r.product_handle !== p.h) || (r.handle && r.handle !== p.h)) return null;
    const camel = r.product_handle !== undefined || r.review_url !== undefined;
    const x = camel
      ? {
          id: r.id,
          publisher: r.publisher,
          publisherGroup: r.publisher_group || r.publisher,
          sourceURL: r.review_url,
          author: r.author || '',
          published: r.published || null,
          updated: r.updated || null,
          language: r.language || 'en',
          summary: r.summary || '',
          positive: r.positive || r.summary || '',
          caution: r.caution || '',
          score: number(r.native_score),
          scaleMax: number(r.native_maximum),
          scaleSourceURL: r.scale_source_url || null,
          scoreKind: r.score_kind || null,
          metric: r.metric || null,
          contentType: r.content_type || null,
          rankingEligible: r.ranking_eligible !== false && number(r.native_score) !== null,
          sourceTitleLabel: r.title || '',
          mediaType: r.media_type || (r.video_id ? 'video' : 'article'),
          videoId: r.video_id || null,
          videoStartSeconds: number(r.video_start_seconds),
          sourceClass: r.source_class || null,
          relationship: r.relationship || null,
          logoURL: r.logo_url || null,
          logoAlt: r.logo_alt || r.publisher,
          videoPlatform: r.video_platform || (r.video_id ? 'youtube' : null),
          disclosure: r.disclosure || '',
          checked: r.checked || null,
        }
      : { ...r };
    return {
      ...x,
      handle: p.h,
      product: p.n,
      catalogStatus: 'active',
      exactModelMatch: true,
      previewVisible: true,
      approvedForProduction: true,
    };
  }

  async function loadSectionJSON(url, selector) {
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(url + ' returned ' + response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return readJSON(doc.querySelector(selector)) || [];
    } catch (error) {
      console.warn(error);
      return [];
    }
  }

  const loadMeasurements = () => loadSectionJSON(config.measurementsURL, '[data-ls-measurements]');
  const loadExpertReviews = () => loadSectionJSON(config.expertReviewsURL, '[data-ls-expert-reviews]');

  async function loadTarget() {
    if (config.rigFamily !== '711') return null;
    try {
      const target = await fetch(config.targetURL).then((r) => r.json());
      return { ...target.reference, approved: true };
    } catch (error) {
      console.warn(error);
      return null;
    }
  }

  function toMeasurement(m, product) {
    return {
      id: m.id,
      handle: m.h,
      name: product.name,
      edition: product.name,
      kind: 'measurement-derived',
      form: 'in-ear',
      rigFamily: config.rigFamily,
      provider: m.provider || 'Linsoul',
      sourceURL: product.url,
      providerURL: window.location.origin,
      channel: m.channel || '',
      tips: '',
      insertion: '',
      processing: [m.smoothing && m.smoothing + ' smoothing', m.rig].filter(Boolean).join(' / '),
      sourceDate: m.date,
      retrieved: m.date || config.today,
      points: m.pts,
      approved: true,
    };
  }

  async function start() {
    const [raw, snapshot, liveMeasurements, target, expertReviews] = await Promise.all([
      loadCatalog(),
      config.preview ? fetch(config.previewURL).then((r) => r.json()) : null,
      loadMeasurements(),
      loadTarget(),
      loadExpertReviews(),
    ]);
    const reviewsByHandle = new Map();
    expertReviews.forEach((r) => {
      if (!reviewsByHandle.has(r.product_handle)) reviewsByHandle.set(r.product_handle, []);
      reviewsByHandle.get(r.product_handle).push(r);
    });
    const taxonomy = snapshot?.taxonomy || {};
    const products = [];
    const owners = {};
    const editorial = [];
    const withEditorial = new Set();

    raw.forEach((p) => {
      const product = toProduct(p, taxonomy);
      if (product.type !== 'Wired IEM' && product.type !== 'Headphones') return;
      products.push(product);
      const owner = toOwner(p, product);
      if (owner) owners[p.h] = owner;
      [...(p.er || []), ...(reviewsByHandle.get(p.h) || [])].forEach((r) => {
        const review = toEditorial(r, p);
        if (review) {
          editorial.push(review);
          withEditorial.add(p.h);
        }
      });
    });

    const handles = new Set(products.map((p) => p.handle));
    const fromSnapshot = (list) => (list || []).filter((r) => handles.has(r.handle) && !withEditorial.has(r.handle));
    const partners = {
      schemaVersion: '1.0',
      snapshot: config.today,
      reviews: [...editorial, ...(snapshot ? fromSnapshot(snapshot.partners.reviews) : [])],
      rankingPolicy: snapshot?.partners.rankingPolicy,
    };
    const experts = snapshot
      ? { ...snapshot.experts, records: fromSnapshot(snapshot.experts.records) }
      : { records: [] };
    const byHandle = new Map(products.map((p) => [p.handle, p]));
    const live = liveMeasurements
      .filter((m) => byHandle.get(m.h)?.type === 'Wired IEM')
      .map((m) => toMeasurement(m, byHandle.get(m.h)));
    const liveHandles = new Set(live.map((m) => m.handle));
    const snapshotMeasurements = snapshot?.measurements;
    const measurements = {
      schemaVersion: '1.0',
      retrieved: config.today,
      form: 'in-ear',
      rigFamily: config.rigFamily,
      normalizationHz: 1000,
      reference:
        target || (snapshotMeasurements?.rigFamily === config.rigFamily ? snapshotMeasurements.reference : null),
      products: [
        ...live,
        ...(snapshotMeasurements?.products || []).filter((m) => handles.has(m.handle) && !liveHandles.has(m.handle)),
      ],
      limitations: [
        'Linsoul measurements are exported from REW and normalized at 1 kHz; compare only curves from the same coupler.',
        ...(target ? [] : ['No target curve is shown until the coupler for Linsoul measurements is confirmed.']),
      ],
    };

    if (measurements.products.length) await loadScript(config.d3URL);

    localizeBands();
    root._rankings = window.LinsoulRankingsPage.mount(root, {
      catalog: { schemaVersion: '1.0', snapshot: config.today, currency: config.money.currency, products },
      experts,
      owners: { products: owners },
      measurements,
      partners,
      preview: config.preview,
      routes: config.routes,
      technologyRoutes: config.technologyRoutes,
      priceNote: 'Live store price. Confirm options and availability on the product page.',
      publishedLabel: config.publishedLabel || '',
    });
  }

  start().catch(fail);
})();
